import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, from, of, zip } from 'rxjs';
import { map, reduce, tap, switchMap, filter, takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { Store } from '@ngrx/store';
import { get } from 'lodash';

import { CollectionScreenComponent } from '@core/features/collection-screen.component';
import * as fromStore from '@app/core/store';
import { Column, ColumnGroup, ResponsiveResolution, retrieveKeys } from '@core/utils/collection.util';
import { FeatureService } from '@services/feature/feature.service';
import * as fromMaster from '@features/master/search-0/store';




import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;
/*
 * Search component for Master feature responsible of displaying
 * items list within a grid component
 * The items value can be passed as @input or by calling a remote REST service
 * using the input parameters
 */
@Component({
  selector: 'app-master-search-0',
  templateUrl: './master-search-0.component.html'
})
 export class MasterSearch0Component extends CollectionScreenComponent implements OnInit, OnDestroy {

  vars: any = {};
  loading$: Observable<boolean>;
  value$: Observable<any[]>;
  value: any[];
  rowsSelected$: Observable<any[]>;

  currentPage$;
  pageSize$;

  count$;
  criteria;
  
pageSize = 10;
items: any[];
selectedItems: any[];
columns: Column[] = [
];
  
 rowOperations$: Observable<MenuItem[]>;
  
  




  /** @inheritDoc */
  constructor(
    private featureService: FeatureService,
    private confirmationServ: ConfirmationService,
    
    router: Router,
    store: Store<fromMaster.State>,
    route: ActivatedRoute
  ) {
    super(route, store, router);
  }

  ngOnInit() {
    super.ngOnInit();
    this.criteria = this.activeRoute.snapshot.data.inputs ? this.activeRoute.snapshot.data.inputs.criteria : undefined;
    this.keys = retrieveKeys(this.columns);
    this.params = { ...this.params,  ...this.activeRoute.snapshot.queryParams, ...this.initParams() };
    this.selectedColumns = this.columns;
    this.store.dispatch(fromMaster.initAction({ ...this.params }));
    this.store.dispatch(fromMaster.searchAction({ ...this.params, activeRoute: this.activeRoute }));
    this.store.dispatch(fromMaster.countAction({ ...this.params, activeRoute: this.activeRoute }));
    this.currentPage$ = this.store.select(fromStore.selectPage, this.ctx);
    this.pageSize$ = this.store.select(fromStore.selectPageSize, this.ctx);
    this.value$ = this.store.select(fromStore.selectValue, this.ctx).pipe(
      fromStore.distinctUntilBeChanged,
      tap(items => this.value = items)
    );
    this.loading$ = this.store.select(fromStore.selectLoading, this.ctx);
    this.count$ = this.store.select(fromStore.selectCount, this.ctx);
    this.store.select(fromStore.selectSearchVars, this.ctx).pipe(
      takeUntil(this.destroy$),
    ).subscribe(data => {
      this.vars = { ...data };
    });
    this.rowsSelected$ = this.store.select(
      fromStore.selectRowsSelected,
      this.ctx
    );
  
  
  }

  initParams(): any {
    return {
      totalItems: this.totalItems,
      page: 1,
      size: this.pageSize,
      keys: this.keys,
      order: this.orderBy,
      criteria: this.criteria,
      vars: { page: 1, size: this.pageSize, keys: this.keys }
    };
  }

  getScreenCtx() {
    return fromStore.buildScreenCtx('Master', 'Search0', this.screenId);
  }

  /**
   * Paginates the retrieved data
   * @param {PageChange} event - The PageChange event
   */
  paginate(event) {
    this.store.dispatch(
      fromMaster.searchAction({
        ...this.params,
        loading: true,
        size: event.rows,
        page: event.page+1,
        vars: { ...this.vars, size: event.rows, page: event.page + 1 }
      })
    );
  }

/**
  * Get date format from the profile
  * @param {string} temporalType
  * @param {string} datePrecision
  * @return {string} the date format
  */
  getDateFormat(temporalType: string, datePrecision?: string): string {
    return this.featureService.profileService.getDateFormat(temporalType, datePrecision);
  }

  
  /**
* Get the data to dispatch by ngrx actions
*/
getActionPayload() {
 return {
    ...this.params,
    ctx: {...this.ctx},
    activeRoute: this.activeRoute,
    vars: { ...this.vars },
    data: this.selectedItems instanceof Array ? this.selectedItems[0]: this.selectedItems,
      rowId: this.selectedItems?this.selectedItems['code']:undefined,
    value: this.value
    }
}
    onSelectionChange() {
    this.store.dispatch(
      fromMaster.rowsSelectionChangeAction({
        ...this.params,
        rowsSelected: [this.selectedItems]
      })
    );
  }
  
  



  






 }

